import { CreateWalkInConsultRequest } from "@shared/zod/schemas/requests/walkInConsult"
import {
  WalkInConsultCreationResponse,
  WalkInConsultPossibleResponse,
} from "@shared/zod/schemas/responses/walkInConsult"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const walkInConsultPossible = (): Promise<WalkInConsultPossibleResponse> => {
  return axiosPatient({
    url: "/patient/walkinconsults/possible",
    method: "get",
  }).then((resp) => resp.data)
}

export const createWalkInConsult = (req: CreateWalkInConsultRequest): Promise<WalkInConsultCreationResponse> => {
  return axiosPatient({
    url: "/patient/walkinconsults",
    method: "post",
    data: req,
  }).then((resp) => resp.data)
}
